import { render, staticRenderFns } from "./DebtorAnalysisStatistic.vue?vue&type=template&id=068503b0&scoped=true"
import script from "./DebtorAnalysisStatistic.vue?vue&type=script&lang=ts"
export * from "./DebtorAnalysisStatistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068503b0",
  null
  
)

export default component.exports